import React from 'react';
import PropTypes from 'prop-types';

import { StyledSvg } from './smart-filter-indicator.style';

/**
 * The smart filter shape/indicator component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.type - shape of indicator
 * @param {string} props.color - fill color of the indicator
 * @param {string} props.opacity - opacity of the indicator
 * @param {object} props.size - size of the indicator
 * @return {element}
 */
const SmartFilterIndicator = ({
  type, color, opacity, size,
}) => (
  <>
    {type === 'diamond'
        && (
        <StyledSvg
          color={color}
          opacity={opacity}
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 12 12"
        >
          <path id="Polygon_3" data-name="Polygon 3" d="M6,0l6,6L6,12,0,6Z" />
        </StyledSvg>
        )}
    {type === 'octagon'
        && (
        <StyledSvg
          color={color}
          opacity={opacity}
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 12 12"
        >
          <path id="Path_640" data-name="Path 640" d="M13.54,22,10,18.475v-4.95L13.54,10h4.95L22,13.525v4.95L18.49,22Z" transform="translate(-10 -10)" />
        </StyledSvg>
        )}
    {type === 'radioButtonFilled'
      && (
        <StyledSvg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
          <g id="Group_4200" data-name="Group 4200" transform="translate(-44 -252.004)">
            <g id="Group_3441" data-name="Group 3441" transform="translate(44 252.004)">
              <g id="Path_559" data-name="Path 559" fill="none">
                <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none" />
                <path
                  d="M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
                  stroke="none"
                  fill={color}
                />
              </g>
            </g>
            <circle id="Ellipse_512" data-name="Ellipse 512" cx="5" cy="5" r="5" transform="translate(49 257)" fill={color} />
          </g>
        </StyledSvg>
      )}
    {type === 'radioButtonCircle'
      && (
      <StyledSvg id="Group_3441" data-name="Group 3441" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20">
        <g id="Path_559" data-name="Path 559" fill="none">
          <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none" />
          <path
            d="M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 C 1 14.96261978149414 5.037380218505859 19 10 19 C 14.96261978149414 19 19 14.96261978149414 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z"
            stroke="none"
            fill={color}
          />
        </g>
      </StyledSvg>
      )}
  </>
);

SmartFilterIndicator.propTypes = {
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  opacity: PropTypes.string,
  size: PropTypes.string.isRequired,
};

SmartFilterIndicator.defaultProps = {
  color: 'white',
  opacity: '1.0',
};

export default SmartFilterIndicator;
